import { render, staticRenderFns } from "./FCR.vue?vue&type=template&id=60c71a06&"
import script from "./FCR.vue?vue&type=script&lang=js&"
export * from "./FCR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports